import React, { useState } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import shortid from 'shortid';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import { IconButton, Box } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import CancelIcon from '@material-ui/icons/Cancel';
import UnfoldMoreIcon from '@material-ui/icons/UnfoldMore';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemIcon from '@material-ui/core/ListItemIcon';

import useTimeline from '../timeline/useTimeline';
import { legendItemsCards, legendItemsOthers } from '../../../utils/icons';

export default function TimelineLegend() {
  const { toggleFlag } = useTimeline();

  const [showMore, setShowMore] = useState(false);

  const renderLegendItems = item => {
    return (
      <ListItem className="legend-list-icon" key={shortid.generate()}>
        <ListItemIcon className="legend-icon">{item.iconComponent}</ListItemIcon>
        <ListItemText primary={item.title} />
      </ListItem>
    );
  };

  const renderGroupsOfLegends = group => {
    return (
      <Grid item xs={2} key={shortid.generate()}>
        <List className="legend-list-wrap">{group.map(renderLegendItems)}</List>
      </Grid>
    );
  };

  return (
    <SwipeableDrawer
      anchor="bottom"
      open
      onClose={() => {}}
      onOpen={() => {}}
      variant="persistent"
      PaperProps={{
        style: { opacity: '0.95' },
      }}
    >
      <Box className="card-icons" pl={2}>
        <Box>
          {/* <Typography variant="h4" pl={2}>
            {' '}
            Card Icons
          </Typography> */}
          <Box>
            <IconButton onClick={() => toggleFlag('showLegend')} style={{ float: 'right' }}>
              <CancelIcon />
            </IconButton>
            <IconButton onClick={() => setShowMore(!showMore)} style={{ float: 'right' }}>
              <UnfoldMoreIcon />
            </IconButton>
          </Box>
        </Box>

        <Box display="flex" flexDirection="column" className="legend-section">
          <Grid className="card-icons-section" container>
            {legendItemsCards.map(renderGroupsOfLegends)}
          </Grid>
          {showMore && (
            <div style={{ height: '100px' }}>
              <Grid className="other-icons-section" container>
                {legendItemsOthers.map(renderGroupsOfLegends)}
              </Grid>
            </div>
          )}
        </Box>
      </Box>
    </SwipeableDrawer>
  );
}
